import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { doorPeripheralsSelector } from 'selectors/components'
import deviceTypeName from 'helpers/accessControl/deviceTypeName'
import { ACCESS_TYPE_MAP } from 'helpers/globals'

function mapStateToProps(state) {
  return {
    devices: doorPeripheralsSelector(state)
  }
}

const ConfigurationDetails = ({ devices, isExport, classes }) =>
  <div className={isExport ? classes.exportContainer : classes.container}>
    { isExport && <strong>Device Details:</strong> }
    { devices.length > 0
      ? <table className={classes.table} cellSpacing='0' style={{ marginLeft: isExport ? '.5rem' : 0 }}>
          <thead>
            <tr>
              <th>Device</th>
              <th>Type</th>
              <th>Wire</th>
            </tr>
          </thead>
          <tbody>
            { devices.map(({ id, peripheralType, protocol, type, wireType, wireShielded }) =>
                <tr key={peripheralType + id}>
                  <td>{peripheralType === 'readers' ? `${protocol} ${deviceTypeName(peripheralType)}` : deviceTypeName(peripheralType)}</td>
                  <td>{(ACCESS_TYPE_MAP[peripheralType].length || ['auxiliaryInputs', 'auxiliaryOutputs'].includes(peripheralType)) ? type : '—'}</td>
                  <td>{wireType} {wireShielded ? 'Shielded' : 'Unshielded'}</td>
                </tr>
              )
            }
          </tbody>
        </table>
      : (isExport ? <span>No devices yet</span> : <em style={{ marginBottom: '.8rem' }}>No devices yet</em>)
    }
  </div>

export default connect(mapStateToProps)(injectSheet(style)(ConfigurationDetails))



// WEBPACK FOOTER //
// ./src/components/DoorDetails/ConfigurationDetails/index.js